import type Theme from '@jetbrains/ring-ui-built/components/global/theme'

import {getCurrentTheme} from '../../selectors/getCurrentTheme'
import {useAppSelector} from '../react-redux'

export function useUserTheme(): Theme {
  return useAppSelector(getCurrentTheme)
}
